import { Navigate, Outlet } from "react-router-dom";
import { useUserContext } from "@/context/UserContext";
import { RouteFallback } from "@/routes/RouteFallback";

/** Restricts /management/* to Manager accounts inside the company AppLayout. */
export function ManagerManagementRoute() {
  const { userDetails } = useUserContext();

  if (userDetails === undefined) {
    return <RouteFallback />;
  }

  if (userDetails?.role !== "MANAGER") {
    return <Navigate to="/my-discovery" replace />;
  }

  return <Outlet />;
}
